import { isUndefined, isDefined } from 'utils/tsHelpers';
import { TriggerProps } from '../types';

export const getTriggerStyleProps = ({
  hasError,
  isDisabled,
  hasWarning,
  isEmpty,
  isGhost,
  isLoading,
  isReadOnly,
  variant,
}: Omit<TriggerProps, 'onClick'>) => {
  return {
    ...(isDefined(variant) && { variant }),
    ...(isUndefined(variant) && {
      'data-empty': isEmpty,
      'data-disabled': isReadOnly || isDisabled,
      'data-error': hasError,
      'data-ghost': isGhost,
      'data-warning': hasWarning,
      'data-loading': isLoading,
    }),
  };
};
